// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skills {
  padding: 120px 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.skills-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.skills-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 3rem;
  margin-top: 3rem;
}

.skills-column {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.skills-subtitle {
  color: #2c3e50;
  font-size: 1.5rem;
  margin-bottom: 2rem;
  position: relative;
}

.skills-subtitle::after {
  content: '';
  position: absolute;
  bottom: -0.5rem;
  left: 0;
  width: 50px;
  height: 3px;
  background: #3498db;
  border-radius: 2px;
}

.skill-item {
  margin-bottom: 1.5rem;
}

.skill-info {
  display: flex;
  justify-content: center;
  /* justify-content: space-between; */
  margin-bottom: 0.5rem;
}

.skill-name {
  color: #2c3e50;
  font-weight: 700;
  font-size: large;
}

.skill-percentage {
  color: #3498db;
  font-weight: 600;
}

.skill-bar {
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
}

.skill-progress {
  height: 100%;
  background: linear-gradient(90deg, #3498db, #2980b9);
  border-radius: 4px;
  position: relative;
  transition: width 1s ease-in-out;
}

.skill-progress-glow {
  position: absolute;
  top: 0;
  right: 0;
  width: 5px;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
  filter: blur(3px);
}

.interests-grid {
  display: grid;
  gap: 1rem;
}

.interest-card {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 15px;
  transition: all 0.3s ease;
}

.interest-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.interest-title {
  color: #3498db;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}

.interest-description {
  color: #6c757d;
  font-size: 0.9rem;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .skills-grid {
    grid-template-columns: 1fr;
  }
}

@keyframes progressAnimation {
  from {
    width: 0;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Skills/Skills.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,QAAQ;EACV;AACF","sourcesContent":[".skills {\n  padding: 120px 0;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n}\n\n.skills-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.skills-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 3rem;\n  margin-top: 3rem;\n}\n\n.skills-column {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n}\n\n.skills-subtitle {\n  color: #2c3e50;\n  font-size: 1.5rem;\n  margin-bottom: 2rem;\n  position: relative;\n}\n\n.skills-subtitle::after {\n  content: '';\n  position: absolute;\n  bottom: -0.5rem;\n  left: 0;\n  width: 50px;\n  height: 3px;\n  background: #3498db;\n  border-radius: 2px;\n}\n\n.skill-item {\n  margin-bottom: 1.5rem;\n}\n\n.skill-info {\n  display: flex;\n  justify-content: center;\n  /* justify-content: space-between; */\n  margin-bottom: 0.5rem;\n}\n\n.skill-name {\n  color: #2c3e50;\n  font-weight: 700;\n  font-size: large;\n}\n\n.skill-percentage {\n  color: #3498db;\n  font-weight: 600;\n}\n\n.skill-bar {\n  height: 8px;\n  background: #e9ecef;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.skill-progress {\n  height: 100%;\n  background: linear-gradient(90deg, #3498db, #2980b9);\n  border-radius: 4px;\n  position: relative;\n  transition: width 1s ease-in-out;\n}\n\n.skill-progress-glow {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 5px;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.3);\n  filter: blur(3px);\n}\n\n.interests-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n.interest-card {\n  background: #f8f9fa;\n  padding: 1.5rem;\n  border-radius: 15px;\n  transition: all 0.3s ease;\n}\n\n.interest-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 5px 15px rgba(0,0,0,0.1);\n}\n\n.interest-title {\n  color: #3498db;\n  margin-bottom: 0.5rem;\n  font-size: 1.1rem;\n}\n\n.interest-description {\n  color: #6c757d;\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n@media (max-width: 768px) {\n  .skills-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@keyframes progressAnimation {\n  from {\n    width: 0;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
